/** @type {import('svelte/action').Action<HTMLVideoElement>} */

export function autoplay(node) {
  let unobserve
  const doc = document.documentElement

  const onclick = () => {
    node.play().catch(() => {})
    doc.removeEventListener('click', onclick)
  }

  const ontouchstart = () => {
    node.play().catch(() => {})
    doc.removeEventListener('touchstart', ontouchstart)
  }

  const oncanplay = () => {
    node.removeEventListener('canplay', oncanplay)

    // 1st try: Play video instantly
    node.play().catch(function () {
      // 2nd try: Play video when in view
      if (window.IntersectionObserver) {
        const observer = new IntersectionObserver(function ([entry]) {
          if (entry.isIntersecting) {
            node.play().catch(() => {})
            unobserve()
          }
        })
        observer.observe(node)
        unobserve = () => observer.disconnect()
      } else {
        // 3rd try: Play video on document interaction
        doc.addEventListener('click', onclick)
        doc.addEventListener('touchstart', ontouchstart)
      }
    })
  }

  node.addEventListener('canplay', oncanplay)

  return {
    destroy() {
      node.removeEventListener('canplay', oncanplay)
      doc.removeEventListener('click', onclick)
      doc.removeEventListener('touchstart', ontouchstart)
      if (typeof unobserve === 'function') unobserve()
    }
  }
}
